(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-search"] && !Shopify.designMode) return;
  try {
    



  
  jQuery("document").ready(function()
  {
    jQuery(".layout_buttons img.row").click(function()
    {
		if (jQuery(this).hasClass("inactive"))
        {
          	jQuery(".layout_buttons img.row").show();
          	jQuery(this).hide();
          	jQuery(".products-card").addClass("row-layout");
          
          	jQuery(".layout_buttons img.grid").show();
          	jQuery(".layout_buttons img.grid.active").hide();
          
          	
        }
    });
    
    
    jQuery(".layout_buttons img.grid").click(function()
    {
		if (jQuery(this).hasClass("inactive"))
        {
            jQuery(".layout_buttons img.grid").show();
          	jQuery(this).hide();
          	jQuery(".products-card").removeClass("row-layout");
          
          	jQuery(".layout_buttons img.row").show();
          	jQuery(".layout_buttons img.row.active").hide();
        }
          
      
    });
    
    jQuery(".product-filter-options span").click(function()
    {
		if (jQuery(this).hasClass("inactive_option"))
		{ 
          jQuery(this).removeClass("inactive_option"); 
          jQuery(".active_option").addClass("inactive_option").removeClass("active_option");
          jQuery(this).addClass("active_option");

		  if (jQuery(this).hasClass("show_product_type"))
          {
			jQuery(".expertise-section").hide();
			jQuery(".product-type-section").show();
          }
		
			if (jQuery(this).hasClass("show_product_expertise"))
			{
				jQuery(".expertise-section").show();
				jQuery(".product-type-section").hide(); 
			}

			load_sliders();

		}

    });
    
    

	jQuery("#clear").click(function(e)
    {
		e.stopPropagation();
		jQuery('#s').val("");
    });




	load_sliders();




    
  });
  
  
  function load_sliders()
    {
			
		

      	if (jQuery(window).width() <= 600)
		{
          
          jQuery('.product-card-wrapper:visible').each(function()
          {
          
          	if (!jQuery(this).hasClass('slick-initialized'))
            {
              
              jQuery(this).slick({
				infinite: false,
				arrows:false,
				dots:false,
				
				 responsive: [
				
				{
					 breakpoint: 601,
				  settings: {
					slidesToShow: 1,
				  }
				 }	 
				 
				 ]
				
				
				
				});
            
            }
            
            
          });

		}
    }
 


  } catch(e) { console.error(e); }
})();
})();
